import { IEditDishRestaurantPropertiesState } from './editDishRestaurantPropertiesContext';
import {
	TEditDishRestaurantPropertiesAction,
	EditDishRestaurantPropertiesActionTypes,
} from './editDishRestaurantPropertiesActions';

export const editDishRestaurantPropertiesReducer = (
	state: IEditDishRestaurantPropertiesState,
	action: TEditDishRestaurantPropertiesAction,
): IEditDishRestaurantPropertiesState => {
	switch (action.type) {
		case EditDishRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_ALL_DATA:
			return {
				...state,
				dishId: action.payload.dishId,
				dishName: action.payload.dishName,
				isCreatedOnPos: action.payload.isCreatedOnPos,
				isPortionEnabled: action.payload.isPortionEnabled,
				customerName: action.payload.customerName,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				fetchedRestaurants: action.payload.fetchedRestaurants,
				restaurantsWithPortionsIds: action.payload.restaurantsWithPortionsIds,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				categories: action.payload.categories,
				price: action.payload.price,
				openPrice: action.payload.openPrice,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
				hasOpenPrice: action.payload.hasOpenPrice,
				inStop: action.payload.inStop,
				isCommentVisible: action.payload.isCommentVisible,
				isFiscalized: action.payload.isFiscalized,
				taxPercent: action.payload.taxPercent,
				isTaxPercentProtectedFromSync: action.payload.isTaxPercentProtectedFromSync,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				hasPortions: action.payload.hasPortions,
				portionSelectionMode: action.payload.portionSelectionMode,
				hasPortionBasedModGroups: action.payload.hasPortionBasedModGroups,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT:
			return {
				...state,
				categories: action.payload.categories,
				price: action.payload.price,
				openPrice: action.payload.openPrice,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
				hasOpenPrice: action.payload.hasOpenPrice,
				inStop: action.payload.inStop,
				isCommentVisible: action.payload.isCommentVisible,
				isFiscalized: action.payload.isFiscalized,
				taxPercent: action.payload.taxPercent,
				isTaxPercentProtectedFromSync: action.payload.isTaxPercentProtectedFromSync,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				hasPortions: action.payload.hasPortions,
				portionSelectionMode: action.payload.portionSelectionMode,
				hasPortionBasedModGroups: action.payload.hasPortionBasedModGroups,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_OPEN_PRICE:
			return {
				...state,
				openPrice: action.payload.openPrice,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD:
			return {
				...state,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
			};
		case EditDishRestaurantPropertiesActionTypes.TOGGLE_HAS_OPEN_PRICE:
			return {
				...state,
				hasOpenPrice: !state.hasOpenPrice,
				openPriceMaxThreshold: state.hasOpenPrice ? null : state.openPriceMaxThreshold,
			};
		case EditDishRestaurantPropertiesActionTypes.TOGGLE_IN_STOP:
			return {
				...state,
				inStop: !state.inStop,
			};
		case EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_COMMENT_VISIBLE:
			return {
				...state,
				isCommentVisible: !state.isCommentVisible,
			};
		case EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_FISCALIZED:
			return {
				...state,
				isFiscalized: !state.isFiscalized,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_PORTION_SELECTION_MODE:
			return {
				...state,
				portionSelectionMode: action.payload.portionSelectionMode,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_TAX_PERCENT:
			return {
				...state,
				taxPercent: action.payload.taxPercent,
			};
		case EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC:
			return {
				...state,
				isTaxPercentProtectedFromSync: !state.isTaxPercentProtectedFromSync,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP:
			return {
				...state,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA:
			return {
				...state,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
			};
		case EditDishRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditDishRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
